import {
  setCalendarEventFlag,
  setCustomerPaymentFlag,
  setDevModeJson,
  setMediaPaymentFlag,
  setPackageFlag,
  setPlanDiscount,
  setQuotationFlag,
  setUserEventFlag,
  setUserTransactionFlag,
  setWalletManagementFlag,
  setWhiteLabelFlag,
  setOrdersFlag,
  setWhatsAppFlag,
  setLeadsFlag,
} from "../Redux/Slice/Dashboard/FlagSlice";
import store from "../Redux/Store";
import { remoteConfig } from "../firebase";
import { getValue } from "firebase/remote-config";
if (process.env.REACT_APP_NODE_ENV === "dev" || process.env.REACT_APP_NODE_ENV === "local") {
  remoteConfig.settings.minimumFetchIntervalMillis = 0;
} else {
  remoteConfig.settings.minimumFetchIntervalMillis = 360000;
}

import { fetchAndActivate } from "firebase/remote-config";

export const fetchAllRemoteConfig = () => {
  fetchAndActivate(remoteConfig)
    .then(() => {
      let calendarEventValue = getValue(
        remoteConfig,
        "CalendarEvent"
      ).asBoolean();
      let PackageFlag = getValue(remoteConfig, "Package").asBoolean();
      let UserEventFlag = getValue(remoteConfig, "UserEvent").asBoolean();
      let DevModeJson = getValue(remoteConfig, "Dev_Mode").asString();
      if(DevModeJson){
        let DevModeJsonObject = JSON.parse(DevModeJson);
        store.dispatch(setDevModeJson({ value: { isOn: DevModeJsonObject.isOn, allowed: DevModeJsonObject.allowed } }));
      }
      let UserTransactionFlag = getValue(
        remoteConfig,
        "UserTransaction"
      ).asBoolean();
      let QuotationFlag = getValue(remoteConfig, "Quotation").asBoolean();
      let OrdersFlag = getValue(remoteConfig, "Orders").asBoolean();
      let WalletManagement = getValue(
        remoteConfig,
        "WalletManagement"
      ).asBoolean();
      let CustomerPaymentFlag = getValue(
        remoteConfig,
        "CustomerPayment"
      ).asBoolean();
      let MediaPaymentFlag = getValue(remoteConfig, "MediaPayment").asBoolean();
      let WebsiteWhiteLabelFlag = getValue(remoteConfig, "WhiteLabelWebsite").asBoolean();
      let WhatsAppFlag = getValue(remoteConfig, "WhatsApp").asBoolean();
      let LeadsFlag = getValue(remoteConfig, "Leads").asBoolean();
      if (calendarEventValue) {
        store.dispatch(setCalendarEventFlag({ value: calendarEventValue }));
      }
      let plan_discount = getValue(remoteConfig, "plan_discount").asString();
      if (plan_discount) {
        store.dispatch(setPlanDiscount({ value: plan_discount }));
      }
      if (PackageFlag) {
        store.dispatch(setPackageFlag({ value: PackageFlag }));
      }

      if (UserEventFlag) {
        store.dispatch(setUserEventFlag({ value: UserEventFlag }));
      }
      if (UserTransactionFlag) {
        store.dispatch(setUserTransactionFlag({ value: UserTransactionFlag }));
      }
      store.dispatch(setQuotationFlag({ value: QuotationFlag }));
      store.dispatch(setOrdersFlag({ value: OrdersFlag }));
      if (WalletManagement) {
        store.dispatch(setWalletManagementFlag({ value: WalletManagement }));
      }
      if (CustomerPaymentFlag) {
        store.dispatch(setCustomerPaymentFlag({ value: CustomerPaymentFlag }));
      }
      if (MediaPaymentFlag) {
        store.dispatch(setMediaPaymentFlag({ value: MediaPaymentFlag }));
      }
      if (WebsiteWhiteLabelFlag) {
        store.dispatch(setWhiteLabelFlag({ value: WebsiteWhiteLabelFlag }))
      }
      if (WhatsAppFlag) {
        store.dispatch(setWhatsAppFlag({ value: WhatsAppFlag }));
      }
      if (LeadsFlag) {
        store.dispatch(setLeadsFlag({ value: LeadsFlag }));
      }
    })
    .catch((err) => {
      // ...
      console.log("error in flags", err);
    });
};
